var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "b-btn",
        {
          staticClass: "btn-card-action btn-card-action-green my-1",
          attrs: { to: { name: _vm.link, params: { id: _vm.purchase.id } } },
        },
        [_vm._v("Редактировать")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }